import { render, staticRenderFns } from "./BuyVipBox.vue?vue&type=template&id=557268bd"
import script from "./BuyVipBox.vue?vue&type=script&lang=js"
export * from "./BuyVipBox.vue?vue&type=script&lang=js"
import style0 from "./BuyVipBox.vue?vue&type=style&index=0&id=557268bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports